import React, { useState } from 'react';
import '../../../../styles/table.admin.css';
import styles from './nftInfo.module.css';
import axios from 'axios';
import config from '../../../../config/environment';
import './testStyles.css'
import TableComponent from './tableComponent';


export default function AddressInfoPage () {
    let PAGE = 1;

    const querryPrepare = (state) => {
        let tmp = "";
        let start = true
        for(const [key, value] of Object.entries(state)){
            if(value){
                if (start){
                    tmp += `${key}=${value}&`;
                }else{
                    tmp += `${key}=${value}`;
                    start = false
                }
            }
        }
        return tmp;
    };

    const [state, setSelectNetworkState] = useState({
        page: 1,
        toAddress: '',
        currencyCode: ''
    });

    const updateSelectValue = (event) => {
        setSelectNetworkState({
            ...state,
            currencyCode: event.target.value
        })
        setErrorState({
            ...errorState,
            currencyCodeError: false
        });
    };

    const updateInpConValue = (event) => {
        setSelectNetworkState({
            ...state,
            toAddress: event.target.value
        });
        setErrorState({
            ...errorState,
            toAddressError: false
        });
    };

    const updateInpPageValue = (event) => {
        setSelectNetworkState({
            ...state,
            page: event.target.value
        });
        setErrorState({
            ...errorState,
            pageError: false
        });
    };

    const [errorState, setErrorState] = useState({
        pageError: false,
        toAddressError: false,
        currencyCodeError: false,
        showTable: false,
        data: null,
        textButton: "Submit"
    });

    const getInfo = async (e) =>{
        setErrorState({
            ...errorState,
            textButton:"Submit"
        })
        if(state.currencyCode === "DEFAULT" || !state.currencyCode){
            setErrorState({
                ...errorState,
                currencyCodeError: true
            })
            return
        }
        
        if(!state.toAddress.match("0x") && state.toAddress !== ""){
            setErrorState({
                ...errorState,
                toAddressError: true
            })
            return
        }

        if(state.page === ""){
            setSelectNetworkState({
                ...state,
                page: 1
            })
        }

        if(!Number(state.page) && state.page !== ""){
            setErrorState({
                ...errorState,
                pageError: true
            })
            return
        }
        setErrorState({
            ...errorState,
            textButton:"Wait..."
        })

        try {
            PAGE = state.page;
            let querry = config.backendUrl + "/micro-trustee/get-address-info?" + querryPrepare(state)
            await axios.get(querry, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
                }
            }).then(
                (resp) => {
                    setErrorState({
                        ...errorState,
                        showTable: true,
                        data: resp.data,
                        textButton:"Submit"
                    })
                }
            ).catch((error) => {
                alert(error.response.data.message)
                setErrorState({
                    textButton:"Submit"
                })
            })
        } catch (error) {
            alert(error.response.data.message)
            setErrorState({
                ...errorState,
                textButton:"Submit"
            })
        }
    };

    return(
        <div className={styles.wrapper}>
            <div className={styles.select_network}>
                <div className={styles.select_network_wrap}>
                    <select onChange={updateSelectValue} style={errorState.currencyCodeError ? {border: "3px solid red"} : {border: "1px solid #1F082B"}} className={styles.select_network_item}>
                        <option value="DEFAULT">Select the network</option>
                        <option value="BNB">BNB</option>
                        <option value="MATIC">MATIC</option>
                        <option value="ONE">ONE</option>
                    </select>
                    <input className={styles.input_select_network} style={errorState.toAddressError ? {border: "3px solid red"} : {border: "1px solid #1F082B"}} onChange={updateInpConValue} type="text" placeholder='Recipient address (optional)'/>
                    <input className={styles.input_select_network_page} style={errorState.pageError ? {border: "3px solid red"} : {border: "1px solid #1F082B"}} onChange={updateInpPageValue} type="text" placeholder='page'/>
                </div>
                <button className={styles.submit_btn} onClick={getInfo} type='submit'>{errorState.textButton}</button>
            </div>
            <div className="history__table_wrapper_my">
                {
                errorState.showTable ? <TableComponent records = {errorState.data.records} dataPages = {`${errorState.data.pages} страниц`} pages = {PAGE}/> : null
                }
            </div>
        </div>
    );
};
